import { Role } from './Columns'

interface Props {
  roleIds: number[]
  roles: Role[]
}

const CustomRolesCell = ({ roleIds = [], roles = [] }: Props) => {
  return (
    <div>
      {(roles && roleIds && roles.filter((role: Role) => roleIds.includes(role.id))
        .map((role: Role) => role.label).join(', '))}
    </div>
  )
}

export default CustomRolesCell
